import React from 'react'
import { Link } from 'react-router-dom'
import { NotAvailable, Pill } from '@myxplor/ui'
import { conditionalLink } from '../../conditional-link'
import { titleise } from '../../text-transformations'

const careType = ({ type }) => (
  <li>
    <dt title="Care Type">Type</dt>
    <dd>{type ? titleise(type) : <NotAvailable name="Type" />}</dd>
  </li>
)

const isPending = (record) => (
  record.show_migration_pending ?
    <div className="listItemContent--indicators">
      < Pill warning title={record.name + ' has not been migrated to Xplor'}>Pending</Pill>
    </div> :
    null
)

const GovRegistration = ({ record, path, selected = false }) => (
  <div className="listItemContent">
    <div>
      {
        conditionalLink(!selected,
          <Link to={path}>
            <div className="listItemContent--heading">
              {record.name}
            </div>
          </Link>
        )
      }
      <dl className="listItemContent--details">
        {careType(record)}
      </dl>
    </div>

    {isPending(record)}
  </div >
)

export default GovRegistration



// WEBPACK FOOTER //
// ./src/gov-registrations/views/index.jsx